



import useTranslations from "../providers/useTranslations";
import { postToApi } from "../lib/api";

function History(props) {

  const { onClose, setStage, showThanks } = props

  const [history, setHistory] =React.useState([])

  const [show, setShow] =React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [orderSelected, setOrderSelected] =React.useState({
    'orderNumber': '',
    'Business': '',
    'totalcost': '',
    'status': '',
    'tstamp': ''
  });

  const { tr /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  const ordersHistory = JSON.parse(localStorage.getItem('orderHistory'))
  let objHistory = { "orderhistory": ordersHistory }

 React.useEffect(() => {

    //console.log("sending", objHistory)
    postToApi(
      `/api/v1/order/for_ids`,
      { id: 0 },  // dummy user
      objHistory,
      (res) => {
        setHistory(res.result.reverse())
        //console.log(res.result)
      },
      (error) => {
        console.log(error);
      }

    );

  }, [])


  function thanksPageLink(order) {

    // console.log(JSON.parse(order))
    // order = JSON.parse(order)

    let thanksLocation;
    console.log("make Thanks page link for order", order)

    if (order) {
      let deliveryData = {
        destination: order.destination,
        phone: order.phone
      }
      thanksLocation = {
        pathname: '/thanks',
        state: {
          selectedMenu: order,
          items: order.items,
          deliverType: order.deliverType,
          deliveryData: deliveryData,
          paymentMethod: order.paymentMethod,
        }
      }

      if (order.deliverType === 'takeaway') {
        thanksLocation.state.deliveryData = {
          name: order.deliverType.name,
          phone: order.deliverType.phone
        }
      }
    }

    return (
      <a href={thanksLocation} className="col-2 text-center">
        <i className="fa-regular fa-eye" onClick={handleShow} style={{  cursor: "pointer" }}   />
      </a>
    )
  }

  return (
    <section className="section pt-5 pb-5 " >
      <div className="container" >
        <div className="row">
          <div className ="col-md-12 pb-5 text-center">

            <h2 className="mt-2 mb-2 space-between">
              <span className="category-expander" onClick={() => setStage("detail")} style={{
                marginRight: 40
              }}>
                <i className="fa fa-chevron-left fa-2x" aria-hidden="true"  ></i>
              </span>

              {tr("Orders History")}

              <span>&nbsp;</span>
              </h2>
          </div>
        </div>

      </div >
      {/* <div className="row center " style={{ margin: "10px", backgroundColor: "lightgray" }}>

        <h5 className="col-2 centrar" >{tr("Name")}</h5>
        <h5 className=" col-2 centrar">
          {tr("Phone")}
        </h5>
        <h5 className="col-2  centrar">
          {tr("Order")}
        </h5>
        <h5 className="col-2 centrar">{tr("Date")}</h5>
        <h5 className="col-2 centrar">{tr("Total")}</h5>
        <h5 className=" col-2  centrar">
          {tr("Details")}
        </h5>
      </div> */}
      <div className="row"style={{ padding: "10px", margin: "0", backgroundColor: "lightgray" }}>
        <div className="col-2 text-center mt-2 mb-2  history-label " style={{ padding: "0px" }}>
          {tr("Order")} #
        </div>
        <div className="col-3 text-center mt-2 mb-2 history-label" style={{ padding: "0px" }}>
          {tr("Product")}
        </div>
        <div className="col-3 text-center mt-2 mb-2 history-label" style={{ padding: "0px" }}>
          {tr("Business")}
        </div>
        {/* <div className="col-2 text-center mt-2 mb-2 history-label" style={{ padding: "0px" }}>
          {tr("Fecha")}
        </div> */}
        <div className="col-2 text-center mt-2 mb-2 history-label" style={{ padding: "0px" }}>
          {tr("Total")}
        </div>
        <div className="col-2 text-center mt-2 mb-2 history-label" style={{ padding: "0px" }}>
          {tr("Status")}
        </div>
        {/* <div className="col-md-3  text-center">
          <h4 className="mt-2 mb-2">{tr("Orders Id")}</h4>
        </div>
        <div className="col-md-3 text-center">
          <h4 className="mt-2 mb-2">{tr("Product")}</h4>
        </div>
        <div className="col-md-3  text-center">
          <h4 className="mt-2 mb-2">{tr("Businness")}</h4>
        </div>
        <div className="col-md-3  text-center">
          <h4 className="mt-2 mb-2">{tr("Status")}</h4>
        </div> */}

      </div>
      {history
        ? history.map((order, ind) => {
          return (
            <div key={ind}>
              <div className="row"style={{ padding: "10px", margin: "0" }} >
                <div className="col-2 text-center ">
                  <label className="mt-2 mb-2 info-history">{order.orderNumber}</label>
                </div>
                <div className="col-3 text-center">
                  <label className="mt-2 mb-2 info-history">{order.items[0].name}</label>
                </div>
                <div className="col-3 text-center">
                  <label className="mt-2 mb-2 info-history">{order.Business.name}</label>
                </div>
                {/* <div className="col-2 text-center">
                  <label className="mt-2 mb-2 info-history">Fecha</label>
                </div> */}
                <div className="col-2 text-center">
                  <label className="mt-2 mb-2 info-history">{order.totalcost}</label>
                </div>
                <div className="col-2 text-center" onClick={() => setOrderSelected(order)}>
                    {/* <label className="mt-2 mb-2 info-history" onClick={handleShow}>{order.status}</label> */}
                    <i className="fa-regular fa-eye fa-2x" onClick={handleShow} style={{  cursor: "pointer" }}   />
                  </div>

                {/* <div className="col-md-3  text-center">
                  <h5 className="mt-2 mb-2">{order.id}</h5>
                </div>
                <div className="col-md-3  text-center">
                  <h5 className="mt-2 mb-2">{order.items[0].name}</h5>
                </div>
                <div className="col-md-3  text-center">
                  <h5 className="mt-2 mb-2">{order.Business.name}</h5>
                </div>
                <div className="col-md-3  text-center">
                  <h5 className="mt-2 mb-2">{order.status}</h5>
                </div> */}
              </div>
              <hr />
            </div>
          )
        })
        : <div className="container" >
          <div className="row">
            <div className ="col-md-12 pb-5">
              <h1 className="mt-2 mb-2">{tr("Orders History Empty")}</h1>
            </div>
          </div>

        </div >}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{tr('Order Information')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <Modal.Title className='col-6' style={{ fontSize: "15px" }}>{tr('Order number')}</Modal.Title>
            <div className='col-6' style={{ fontSize: "15px" }}>{orderSelected.orderNumber}</div>
            <Modal.Title className='col-6' style={{ fontSize: "15px" }}>{tr('Business')}</Modal.Title>
            <div className='col-6' style={{ fontSize: "15px" }}>{orderSelected.Business.name}</div>
            <Modal.Title className='col-6' style={{ fontSize: "15px" }}>{tr('Total')}</Modal.Title>
            <div className='col-6' style={{ fontSize: "15px" }}>{orderSelected.totalcost}</div>
            <Modal.Title className='col-6' style={{ fontSize: "15px" }}>{tr('Status')}</Modal.Title>
            <div className='col-6' style={{ fontSize: "15px" }}>{orderSelected.status}</div>
            <Modal.Title className='col-6' style={{ fontSize: "15px" }}>{tr('Date')}</Modal.Title>
            <div className='col-6' style={{ fontSize: "15px" }}>{orderSelected.tstamp}</div>
            <Modal.Title className='col-6' style={{ fontSize: "15px" }}>{tr('Destination')}</Modal.Title>
            <div className='col-6' style={{ fontSize: "15px" }}>{orderSelected.destination}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary"  onClick={handleClose}>
            Close
          </button>

        </Modal.Footer>
      </Modal>

    </section>
  );
}

export default History;